import { useState } from 'react';
import { Button, Form } from 'antd';
import classnames from 'classnames/bind';
import { isUndefined } from 'lodash-es';
import { CountryPhoneFieldFormItem } from '@commonPackage/components';
import { checkInternationalPhone, checkInternationalPhoneRequired } from '@portalCommon/utils';
import { formatPhone, validateVerificationCode } from 'common-package/src/utils';
import API from '@/services';
import { RecommendCodeInput } from '..';
import { BaseModal, ModalCommonType } from '.';

import styles from './index.module.less';

const cx = classnames.bind(styles);

export function RecommendCheckPhone(props: ModalCommonType) {
  const { onClose } = props;
  const [form] = Form.useForm();
  const [curCodePhone, setCurCodePhone] = useState('');

  const onFinish = async (value: { phone: { phone: string; code: number }; code: string }) => {
    await form.validateFields([]);

    const {
      phone: { phone, code: areaCode },
      code,
    } = value;
    // 验证手机号与短信验证码
    const { data } = await API.recommend.cluesReferrer(`+${areaCode + phone}`, code);

    onClose(true, data.items);
  };

  const validatePhone = async () => {
    await form.validateFields(['phone']);
    const {
      phone: { code, phone },
      code: verificationCodeValue,
    } = form.getFieldsValue();

    if (!isUndefined(verificationCodeValue)) {
      form.validateFields(['code']);
    }
    const codePhone = formatPhone(code, phone);

    setCurCodePhone(codePhone);
    return phone;
  };

  return (
    <BaseModal onClose={onClose} className={cx('height-450')}>
      <div className={cx('recommend-check-phone')}>
        <h6 className={cx('modal-title')}>查看我的推荐</h6>
        <p className={cx('modal-tip')}>验证你的手机号</p>
        <Form
          form={form}
          labelCol={{ span: 6 }}
          labelAlign="left"
          onFinish={onFinish}
          className={cx('recommend-check-form')}>
          <CountryPhoneFieldFormItem
            labelAlign="left"
            labelName=""
            form={form}
            placeholder="请输入手机号"
            rules={[
              {
                validator: checkInternationalPhoneRequired('请输入您的手机号'),
              },
              {
                validator: checkInternationalPhone(true, '请输入正确的手机号'),
              },
            ]}
          />
          <Form.Item noStyle dependencies={['phone']}>
            {({ getFieldValue }) => (
              <Form.Item
                name="code"
                style={{ marginBottom: 40 }}
                validateFirst
                rules={[
                  {
                    required: true,
                    validateTrigger: ['onBlur'],
                    message: '请输入短信验证码',
                  },
                  {
                    validator: validateVerificationCode({
                      codePhone: curCodePhone,
                      phone: formatPhone(getFieldValue('phone').code, getFieldValue('phone').phone),
                    }),
                  },
                ]}>
                <RecommendCodeInput msgRequest={API.recommend.sendCode} validate={validatePhone} />
              </Form.Item>
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className={cx('submit-btn')}>
              查看我的推荐
            </Button>
          </Form.Item>
        </Form>
      </div>
    </BaseModal>
  );
}
